const t = "{{currentTime}}/{{duration}}", s = "Hakutulokset {{current}}/{{total}}", n = "Tuloksia ei löytynyt", o = "{{count}} tulosta löytyi", i = "{{count}} tulosta löytyi", e = 'Toistetaan kohteesta $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) ja $t(SECONDS, { "count": {{seconds}} }).', a = 'Toistetaan kohteesta , $t(MINUTES, { "count": {{minutes}} }) ja $t(SECONDS, { "count": {{seconds}} }).', T = 'Toistetaan kohteesta $t(SECONDS, { "count": {{seconds}} }).', A = "Virhe tallennettaessa muutoksia transkriptiin.", E = "Transkriptiorivi kohteessa {{time}}. Sisältö on: {{text}}.", c = 'Transkriptiorivien säiliö. Tässä säiliössä $t(TRANSCRIPT_LINES, { "count": {{count}} }). Voit siirtyä tässä säiliössä nuolipainikkeen avulla.', _ = "Muutoksia tallennetaan...", u = "Muutokset tallennettiin litteraattiin.", S = "Päivitä tekstitykset -painike on nyt käytettävissä.", k = "Toiminto", N = "Lisää huomautus kohteessa {{time}}", R = "Lisää kysymyksiä kohdassa {{time}}", O = "Huomautukset", l = "Automaattinen", I = "Automaattinen ({{quality}})", C = "Takaisin", P = "Tekstitykset", U = "Kuvatekstin kieli", r = "Hallitse tekstityksiä", L = "Poista {{language}}", D = "Fonttikoko", M = "Kuvatekstin kieli: {{language}}", y = "{{language}} (automaattinen)", v = "Tyhjennä haku", m = "Sulje", h = "Kommentit", p = "Jatka", Y = "Laske toistonopeutta", G = "Vähennä äänenvoimakkuutta {{percent}}%", H = "Alanuoli", V = "Sulje transkriptioeditori", d = "Päivitä tekstitykset", K = "Virhe!", B = "Tallennetaan...", j = "Tallennettu!", F = "Muokkaa transkriptio", W = "Teksti ei voi olla tyhjä!", $ = "Koko näyttö", g = "{{count}} tunti", J = "{{count}} tuntia", Q = "Kasvata toistonopeutta", x = "Lisää äänenvoimakkuutta arvolla {{percent}}%", Z = "Muuttaa värit käänteisiksi", f = "Siirry tiettyyn prosenttiosuuteen (1-10%, 2-20% jne.)", X = "Siirry alkuun", q = "Toiminnot kohteelle {{title}}", b = "Pikanäppäimet", w = "Kieli", z = "Nuoli vasemmalle", tt = "Päävalikko", st = "{{count}} minuutti", nt = "{{count}} minuuttia", ot = "Mykistä", it = "Mykistetty", et = "Uusi kuvatekstin kieli", at = "Seuraava hakutuloksia", Tt = "Pois", At = "Päällä", Et = "Avaa huomautukset kohteessa {{time}}", ct = "Avaa suoritettu testi kohteessa {{time}}", _t = "Avaa testi kohteessa {{time}}", ut = "Keskeytä", St = "Toista", kt = "Toistonopeus", Nt = "Toistonopeus: {{speed}}x", Rt = "Edellisen kuvatekstin kieli", Ot = "Edellinen hakutulos", lt = "Laatu", It = "Laatuvalikko", Ct = "Toista", Pt = "Nollaa toistonopeus", Ut = "Nuoli oikealle", rt = "Hae transkriptiota", Lt = "{{count}} sekunti", Dt = "{{count}} sekuntia", Mt = "Hae taaksepäin {{seconds}} sekuntia", yt = "Hae eteenpäin: {{seconds}} sekuntia", vt = "Asetukset", mt = "Oikotie", ht = "Median tiedot ja työkalut", pt = "Tyhjä väli", Yt = "Toistonopeuden valikko", Gt = "Aloita automaattinen vieritys", Ht = "Tekstitysten välillä vaihtaminen", Vt = "Vaihtelu mykistetty", dt = "Vaihda Toista / keskeytä", Kt = "on {{count}} transkriptiorivi", Bt = "ovat {{count}} transkriptiorivejä", jt = "Transkriptiota ladataan...", Ft = "Transkription lataus ei onnistunut.", Wt = "Transkriptioasetukset", $t = "Yritä uudelleen", gt = "Transkriptio ei ole saatavissa", Jt = "Ylöspäin nuoli", Qt = "Videoasetukset", xt = "Määrä", Zt = "Äänenvoimakkuus: {{volume}}%", ft = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: s,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: i,
  A11Y_TIMESTAMP_JUMP_HOURS: e,
  A11Y_TIMESTAMP_JUMP_MINUTES: a,
  A11Y_TIMESTAMP_JUMP_SECONDS: T,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: c,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: u,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: k,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: R,
  ANNOTATIONS: O,
  AUTO: l,
  AUTO_QUALITY: I,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: U,
  CAPTIONS_MANAGE: r,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: D,
  CAPTION_LANGUAGE: M,
  CAPTION_LANGUAGE_AUTOMATIC: y,
  CLEAR_SEARCH: v,
  CLOSE: m,
  COMMENTS: h,
  CONTINUE: p,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: G,
  DOWN_ARROW: H,
  EDIT_CLOSE: V,
  EDIT_CONFIRM: d,
  EDIT_ERROR: K,
  EDIT_SAVING: B,
  EDIT_SUCCESS: j,
  EDIT_TRANSCRIPT: F,
  EDIT_VALIDATION_ERROR: W,
  FULLSCREEN: $,
  HOURS: g,
  HOURS_other: J,
  INCREASE_PLAYBACK_SPEED: Q,
  INCREASE_VOLUME: x,
  INVERT_COLORS: Z,
  JUMP_TO_PERCENTAGE: f,
  JUMP_TO_START: X,
  KEBAB_MENU: q,
  KEYBOARD_SHORTCUTS: b,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: st,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: it,
  NEXT_CAPTION_LANGUAGE: et,
  NEXT_HIT: at,
  OFF: Tt,
  ON_TOP: At,
  OPEN_ANNOTATION_AT: Et,
  OPEN_COMPLETED_QUIZ_AT: ct,
  OPEN_QUIZ_AT: _t,
  PAUSE: ut,
  PLAY: St,
  PLAYBACK_SPEED: kt,
  PLAYBACK_SPEED_MESSAGE: Nt,
  PREVIOUS_CAPTION_LANGUAGE: Rt,
  PREVIOUS_HIT: Ot,
  QUALITY: lt,
  QUALITY_MENU: It,
  REPLAY: Ct,
  RESET_PLAYBACK_SPEED: Pt,
  RIGHT_ARROW: Ut,
  SEARCH_TRANSCRIPT_PLACEHOLDER: rt,
  SECONDS: Lt,
  SECONDS_other: Dt,
  SEEK_BACKWARD: Mt,
  SEEK_FORWARD: yt,
  SETTINGS: vt,
  SHORTCUT: mt,
  SIDEBAR: ht,
  SPACE: pt,
  SPEED_MENU: Yt,
  START_AUTOSCROLL: Gt,
  TOGGLE_CAPTIONS: Ht,
  TOGGLE_MUTED: Vt,
  TOGGLE_PLAY_PAUSE: dt,
  TRANSCRIPT_LINES: Kt,
  TRANSCRIPT_LINES_other: Bt,
  TRANSCRIPT_LOADING: jt,
  TRANSCRIPT_LOAD_ERROR: Ft,
  TRANSCRIPT_OPTIONS: Wt,
  TRANSCRIPT_RETRY: $t,
  TRANSCRIPT_UNAVAILABLE: gt,
  UP_ARROW: Jt,
  VIDEO_SETTINGS: Qt,
  VOLUME: xt,
  VOLUME_VALUE: Zt
};
export {
  t as A11Y_DURATION,
  s as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  i as A11Y_SEARCH_RESULTS_FOUND_other,
  e as A11Y_TIMESTAMP_JUMP_HOURS,
  a as A11Y_TIMESTAMP_JUMP_MINUTES,
  T as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  c as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  u as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  k as ACTION,
  N as ADD_ANNOTATION_AT,
  R as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  l as AUTO,
  I as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  U as CAPTIONS_LANGUAGE,
  r as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  D as CAPTION_FONT_SIZE,
  M as CAPTION_LANGUAGE,
  y as CAPTION_LANGUAGE_AUTOMATIC,
  v as CLEAR_SEARCH,
  m as CLOSE,
  h as COMMENTS,
  p as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  G as DECREASE_VOLUME,
  H as DOWN_ARROW,
  V as EDIT_CLOSE,
  d as EDIT_CONFIRM,
  K as EDIT_ERROR,
  B as EDIT_SAVING,
  j as EDIT_SUCCESS,
  F as EDIT_TRANSCRIPT,
  W as EDIT_VALIDATION_ERROR,
  $ as FULLSCREEN,
  g as HOURS,
  J as HOURS_other,
  Q as INCREASE_PLAYBACK_SPEED,
  x as INCREASE_VOLUME,
  Z as INVERT_COLORS,
  f as JUMP_TO_PERCENTAGE,
  X as JUMP_TO_START,
  q as KEBAB_MENU,
  b as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  st as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  it as MUTED,
  et as NEXT_CAPTION_LANGUAGE,
  at as NEXT_HIT,
  Tt as OFF,
  At as ON_TOP,
  Et as OPEN_ANNOTATION_AT,
  ct as OPEN_COMPLETED_QUIZ_AT,
  _t as OPEN_QUIZ_AT,
  ut as PAUSE,
  St as PLAY,
  kt as PLAYBACK_SPEED,
  Nt as PLAYBACK_SPEED_MESSAGE,
  Rt as PREVIOUS_CAPTION_LANGUAGE,
  Ot as PREVIOUS_HIT,
  lt as QUALITY,
  It as QUALITY_MENU,
  Ct as REPLAY,
  Pt as RESET_PLAYBACK_SPEED,
  Ut as RIGHT_ARROW,
  rt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Lt as SECONDS,
  Dt as SECONDS_other,
  Mt as SEEK_BACKWARD,
  yt as SEEK_FORWARD,
  vt as SETTINGS,
  mt as SHORTCUT,
  ht as SIDEBAR,
  pt as SPACE,
  Yt as SPEED_MENU,
  Gt as START_AUTOSCROLL,
  Ht as TOGGLE_CAPTIONS,
  Vt as TOGGLE_MUTED,
  dt as TOGGLE_PLAY_PAUSE,
  Kt as TRANSCRIPT_LINES,
  Bt as TRANSCRIPT_LINES_other,
  jt as TRANSCRIPT_LOADING,
  Ft as TRANSCRIPT_LOAD_ERROR,
  Wt as TRANSCRIPT_OPTIONS,
  $t as TRANSCRIPT_RETRY,
  gt as TRANSCRIPT_UNAVAILABLE,
  Jt as UP_ARROW,
  Qt as VIDEO_SETTINGS,
  xt as VOLUME,
  Zt as VOLUME_VALUE,
  ft as default
};
